import React, { lazy } from 'react';
import { FadeIn } from './Shared';
import { CheckCircle2 } from 'lucide-react';
export const ProductBreakdown = () => {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — El Código de la Calma',
    desc: 'La neurología del berrinche. Por qué pasa, qué ocurre en el cerebro de tu hijo y en el tuyo, y por qué las respuestas instintivas siempre empeoran todo.'
  }, {
    icon: '📗',
    title: 'Tomo 2 — El Protocolo SOS de los 90 Segundos',
    desc: 'Intervención en tiempo real. El protocolo P.A.U.S.A. paso a paso para los próximos 90 segundos de cualquier crisis. Con guión exacto para 5 escenarios.'
  }, {
    icon: '📙',
    title: 'Tomo 3 — El Detector de Humo',
    desc: 'Prevención antes del pico. Cómo detectar las señales antes de que explote todo. El Mapa de Momentos Críticos de tu familia y los 10 Minutos de Oro.'
  }, {
    icon: '📕',
    title: 'Tomo 4 — Límites con Amor',
    desc: 'Firmeza sin guerra. Cómo sostener un límite con calma, sin negociar, sin gritar y sin que el vínculo sufra. El Protocolo de 4 Pasos.'
  }, {
    icon: '📓',
    title: 'Tomo 5 — Reparación y Vínculo',
    desc: 'Cuando vos también explotaste. Qué hacer después. Cómo reparar el vínculo cuando fallaste. Por qué reparar bien vale más que no fallar nunca.'
  }, {
    icon: '📔',
    title: 'Tomo 6 — Kit de Emergencia Móvil',
    desc: 'Todo el sistema en el bolsillo. Las 6 Fichas de Rescate, el Diccionario de Traducción, frases listas y el sistema completo en una página. Para usar en el momento.'
  }];
  const includes = ['Explicación clara sin jerga técnica', 'Protocolo paso a paso aplicable hoy', 'Frases exactas para cada situación', 'Hojas de trabajo completables', 'Versión resumen para consulta rápida', 'Vista previa del tomo siguiente', 'Branding premium — Listo para usar en celular o impreso', 'Compatible con crianza respetuosa y crianza con autoridad'];
  return <section className="py-16 md:py-24 px-4 bg-navy-900/50 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-280">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_0%_0%,rgba(212,175,55,0.05),transparent_70%)] pointer-events-none" data-id="element-281"></div>
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-282">
        <FadeIn data-id="element-283">
          <div className="text-center mb-16" data-id="element-284">
            <div className="inline-block bg-premium-gold/10 text-premium-gold-luminous px-6 py-2 rounded-full text-xs font-bold tracking-[0.3em] mb-6 border border-premium-gold/20 uppercase" data-id="element-285">
              EL SISTEMA COMPLETO
            </div>
            <h2 className="text-4xl md:text-6xl text-white mb-4 tracking-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-286">
              🏆 MEGAPACK <span className="text-[#FFD700]" data-id="element-287">CALMA TOTAL™</span>
            </h2>
            <p className="text-lg md:text-xl font-sans font-medium opacity-90 text-[#FFD700]" data-id="element-288">
              6 Tomos + 4 Bonos + Método Raíces. 350+ páginas — Todo resuelto.
            </p>
          </div>

          <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-start mb-20" data-id="element-289">
            <div className="lg:col-span-7 space-y-5" data-id="element-290">
              {tomos.map((tomo, index) => <div key={index} className="bg-navy-950/60 p-5 md:p-6 rounded-2xl border border-white/5" data-id="element-291">
                  <div className="flex items-start" data-id="element-292">
                    <span className="text-3xl md:text-4xl mr-5" data-id="element-293">
                      {tomo.icon}
                    </span>
                    <div data-id="element-294">
                      <h3 className="text-lg md:text-xl font-sans font-bold text-white mb-2 leading-tight" data-id="element-295">
                        {tomo.title}
                      </h3>
                      <p className="text-gray-300 text-sm leading-relaxed font-sans opacity-90" data-id="element-296">
                        {tomo.desc}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>
            <div className="lg:col-span-5 sticky top-24 hidden lg:block" data-id="element-297">
              <div className="relative w-full max-w-md mx-auto" data-id="element-298">
                <div className="absolute inset-0 bg-premium-gold/10 blur-3xl rounded-full" data-id="element-299"></div>
                <img src="https://cdn.magicpatterns.com/uploads/d2Eudanot4EDAUZoAu2ztw/MockUp-Noches-de-Paz-_2__(2)_(1).webp?w=400" alt="MegaPack" className="relative z-10 w-full h-auto" width={400} height={400} loading="lazy" data-id="element-300" />
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-navy-800 via-navy-900 to-navy-950 border border-white/10 rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-301">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-premium-gold/50 to-transparent" data-id="element-302" />
            <div className="absolute -top-24 -left-24 w-64 h-64 bg-premium-gold/5 blur-3xl rounded-full" data-id="element-303"></div>

            <h3 className="text-2xl md:text-4xl font-bold text-center text-white mb-12 font-[Montserrat,_sans-serif]" data-id="element-304">
              Cada tomo incluye:
            </h3>
            <div className="grid sm:grid-cols-2 gap-4 md:gap-6" data-id="element-305">
              {includes.map((item, index) => <div key={index} className="flex items-center space-x-4 bg-white/5 border border-white/5 p-5 rounded-2xl" data-id="element-306">
                  <CheckCircle2 className="w-6 h-6 text-premium-gold-luminous flex-shrink-0" data-id="element-307" />
                  <span className="text-white font-bold text-sm md:text-base tracking-wide font-sans" data-id="element-308">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};